var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _c(
        "page-limiter",
        [
          _vm.crumbs && _vm.crumbs.length
            ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
            : _vm._e(),
          _vm.page.head
            ? _c("section", { staticClass: "about-head" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "scroll-reveal",
                        rawName: "v-scroll-reveal",
                        value: { delay: 300 },
                        expression: "{delay: 300}"
                      }
                    ],
                    staticClass: "about-head__image-box"
                  },
                  [
                    _vm.page.head.image
                      ? _c("img", {
                          staticClass: "about-head__image",
                          attrs: { src: _vm.page.head.image, alt: "" }
                        })
                      : _vm._e(),
                    _vm.page.head.brandImage
                      ? _c("img", {
                          staticClass: "about-head__brand-image",
                          attrs: { src: _vm.page.head.brandImage, alt: "" }
                        })
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                    ],
                    staticClass: "about-head__text-box"
                  },
                  [
                    _c("h3", { staticClass: "about-head__sub-title" }, [
                      _vm._v(_vm._s(_vm.page.head.subTitle))
                    ]),
                    _c("h2", { staticClass: "about-head__title" }, [
                      _vm._v(_vm._s(_vm.page.head.title))
                    ]),
                    _c("p", [_vm._v(_vm._s(_vm.page.head.text))])
                  ]
                )
              ])
            : _vm._e(),
          _vm.page.mission
            ? _c(
                "section",
                {
                  directives: [
                    { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                  ],
                  staticClass: "about-card about-card--reverse"
                },
                [
                  _c("div", { staticClass: "about-card__image-box" }, [
                    _vm.page.mission.image
                      ? _c("img", {
                          staticClass: "about-card__image",
                          attrs: { src: _vm.page.mission.image, alt: "" }
                        })
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "about-card__text-box" }, [
                    _c("h2", { staticClass: "about-card__title" }, [
                      _vm._v(_vm._s(_vm.page.mission.title))
                    ]),
                    _c("p", [_vm._v(_vm._s(_vm.page.mission.text))])
                  ])
                ]
              )
            : _vm._e(),
          _vm.page.purpose
            ? _c(
                "section",
                {
                  directives: [
                    { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                  ],
                  staticClass: "about-card"
                },
                [
                  _c("div", { staticClass: "about-card__image-box" }, [
                    _vm.page.purpose.image
                      ? _c("img", {
                          staticClass: "about-card__image",
                          attrs: { src: _vm.page.purpose.image, alt: "" }
                        })
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "about-card__text-box" }, [
                    _c("h2", { staticClass: "about-card__title" }, [
                      _vm._v(_vm._s(_vm.page.purpose.title))
                    ]),
                    _c("p", [_vm._v(_vm._s(_vm.page.purpose.text))])
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.page.history
        ? _c("history-section", {
            attrs: { content: _vm.page.history, crumbs: _vm.crumbs }
          })
        : _vm._e(),
      _c("page-limiter", [
        _vm.page.values
          ? _c("section", { staticClass: "about-values" }, [
              _c("h2", { staticClass: "about-values__title" }, [
                _vm._v(_vm._s(_vm.page.values.heading))
              ]),
              _vm.page.values.list
                ? _c(
                    "ul",
                    { staticClass: "about-values-list" },
                    _vm._l(_vm.page.values.list, function(item) {
                      return _c(
                        "li",
                        { staticClass: "about-values-list__item" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "scroll-reveal",
                                  rawName: "v-scroll-reveal",
                                  value: { delay: 300 },
                                  expression: "{delay: 300}"
                                }
                              ],
                              staticClass: "about-values-list__image-box"
                            },
                            [
                              _c("img", {
                                staticClass: "about-values-list__image",
                                attrs: { src: item.image, alt: "" }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "scroll-reveal",
                                  rawName: "v-scroll-reveal"
                                }
                              ],
                              staticClass: "about-values-list__text-box"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "about-values-list__icon" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "40",
                                        height: "40",
                                        viewBox: "0 0 40 40"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M40 20c0-1.6-1.1-3-2.5-3.5.4-.4.8-.9 1-1.5.4-1 .3-2.2-.3-3.2-.7-1.2-2.1-1.9-3.4-1.8.3-.5.4-1.1.4-1.7 0-1-.5-2-1.3-2.7-1.1-.9-2.7-1.1-4-.5 0-.7-.1-1.4-.5-2-.5-.9-1.3-1.5-2.2-1.7-1.4-.4-2.8.1-3.8 1.1-.2-.6-.5-1.1-1-1.5-.8-.7-1.8-1-2.8-.9-1.5.2-2.6 1.2-3.1 2.5-.4-.4-.9-.8-1.5-1-1-.4-2.2-.3-3.2.3-1.2.7-1.9 2-1.8 3.4-.5-.4-1.1-.5-1.7-.5-1 0-2 .5-2.7 1.3-.9 1.1-1.1 2.7-.5 4-.7 0-1.4.1-2 .5-.9.5-1.5 1.3-1.7 2.2-.4 1.4.1 2.8 1.1 3.8-.6.2-1.1.5-1.5 1-.7.8-1 1.8-.9 2.8.2 1.5 1.2 2.6 2.5 3.1-.4.4-.8.9-1 1.5-.4 1-.3 2.2.3 3.2.7 1.2 2.1 1.9 3.4 1.8-.3.5-.4 1.1-.4 1.7 0 1 .5 2 1.3 2.7 1.1.9 2.7 1.1 4 .5 0 .7.1 1.4.5 2 .5.9 1.3 1.5 2.2 1.7 1.4.4 2.8-.1 3.8-1.1.2.6.5 1.1 1 1.5.8.7 1.8 1 2.8.9 1.5-.2 2.6-1.2 3.1-2.5.4.4.9.8 1.5 1 1 .4 2.2.3 3.2-.3 1.2-.7 1.9-2 1.8-3.4.5.3 1.1.4 1.7.4 1 0 2-.5 2.7-1.3.9-1.1 1.1-2.7.5-4 .7 0 1.4-.1 2-.5.9-.5 1.5-1.3 1.7-2.2.4-1.4-.1-2.8-1.1-3.8C38.9 23 40 21.6 40 20z",
                                          fill: "#00b100"
                                        }
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M22.4 22.8l-3.1 3.1c-.4.4-.8.7-1.3.8-.4.1-.9 0-1.3-.2-.2-.1-.4-.3-.6-.5-.3-.3-.6-.5-.8-.8-.5-.5-1.1-1-1.6-1.5s-1.1-1-1.6-1.5c-.4-.4-.9-.7-1.1-1.2-.3-.8-.1-1.9.7-2.4.8-.6 1.9-.4 2.6.3 1 .9 2 1.9 3 2.8.2.2.5.2.7 0l6.2-6.2 1.6-1.6c.4-.4.8-.6 1.3-.7.9-.2 1.8.5 2.1 1.3.2.7.1 1.5-.5 2-2.1 2.2-4.2 4.2-6.3 6.3z",
                                          fill: "#fff"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "h3",
                                { staticClass: "about-values-list__title" },
                                [_vm._v(_vm._s(item.title))]
                              ),
                              _c("p", [_vm._v(_vm._s(item.text))])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _c(
        "page-limiter",
        [
          _c("feedback-tile", {
            directives: [{ name: "scroll-reveal", rawName: "v-scroll-reveal" }],
            attrs: { ya_metrica_goal: "about_request" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4827e3a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4827e3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageAbout.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4827e3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageAbout.vue
// module chunks = 0